import React from 'react'
import './WaitingOnSetup.scss'

const WaitingOnSetup = ({ message }) => {
    return (
        <div className="spinner"><div className="message">{message}</div></div>
        
    )
}
export default WaitingOnSetup